



















import Vue from "vue";
import { Worker } from "../../interfaces/Worker";
export default Vue.extend({
  props: {
    worker: {
      type: Object as () => Worker,
      required: true,
    },
    loading: {
      type: Boolean,
      required: true,
    },
  },
  computed: {
    getHeaders(): any[] {
      return [
        { text: this.$tc("tarif-covid.claims.state"), value: "state" },
        { text: this.$tc("tarif-covid.claims.amount"), value: "amount" },
        { text: this.$tc("tarif-covid.claims.balance"), value: "balance" },
      ];
    },
    getItems(): any[] | undefined {
      return this.worker?.claims?.map(claim => {
        return Object.assign({}, claim, {
          state: this.$tc("tarif-covid.claims." + claim.state),
        });
      });
    },
  },
});
